import { useState } from 'react'

import InfoIcon from '@mui/icons-material/Info'
import LaunchIcon from '@mui/icons-material/Launch'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import Adres from '@components/Adres'
import { DisciplineIcon } from '@components/DisciplineIcon'
import Uitvoerende from '@components/Uitvoerende'
import { formatDate } from '@util/date-util'

import type { Opdracht } from '../../opdracht/types/Opdracht'
import { Link } from '../../router/components/Link'
import { StyledIconLink } from '../../theme/components/StyledIconLink'

import { OpdrachtStatus } from './OpdrachtStatus'

const STATUS_OPLEVERING = 500

export { OpdrachtenTableRow }

interface Props {
  opdracht: Opdracht
  canNavigateToProject?: boolean
}

const OpdrachtenTableRow = ({
  opdracht,
  canNavigateToProject = false,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleMenu = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <>
      <TableRow key={opdracht.opdrachtId}>
        <TableCell>{opdracht.opdrachtId}</TableCell>
        <TableCell>{opdracht.clusterId}</TableCell>
        <TableCell>{opdracht.versieNummer}</TableCell>
        <TableCell>
          <DisciplineIcon
            disciplineCode={opdracht.discipline}
            toolTip={
              /* v8 ignore next - TODO: missing coverage -- @preserve */
              opdracht.discipline === 'M' ? 'Glas' : opdracht.disciplineLabel
            }
          />
        </TableCell>
        <TableCell>
          {opdracht.details && <Adres {...opdracht.details} />}
        </TableCell>
        <TableCell>{opdracht.netbeheerder}</TableCell>
        <TableCell>
          <Uitvoerende {...opdracht} />
        </TableCell>
        <TableCell>
          {formatDate(opdracht.details?.creatieDatum) || 'Onbekend'}
        </TableCell>
        <TableCell>{formatDate(opdracht.changed)}</TableCell>
        <TableCell>
          {opdracht.status === STATUS_OPLEVERING ? (
            <OpdrachtStatus opdracht={opdracht} text={opdracht.statusText} />
          ) : (
            <p>{opdracht.statusText}</p>
          )}
        </TableCell>
        <TableCell>
          <StyledIconLink
            title={`Navigeer naar opdracht ${opdracht.opdrachtId}`}
            icon={<LaunchIcon />}
            href={`/opdracht/${opdracht.opdrachtId}`}
          />
          {canNavigateToProject && (
            <>
              <IconButton data-testid="buttonMenu" onClick={handleMenu}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                data-testid="menu"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  component={Link}
                  to={`/aansluiting/project/${opdracht.clusterId}`}
                >
                  <ListItemIcon>
                    <InfoIcon />
                  </ListItemIcon>
                  <ListItemText primary="Project details" />
                </MenuItem>
              </Menu>
            </>
          )}
        </TableCell>
      </TableRow>
    </>
  )
}
